export class Classification {
  id!: string;
  value!: number;
  portionMark!: string;
  title!: string;
}
